mobileSize = 1130;

$(document).ready(function () {
    const windowSize = $(window).width();
    if (windowSize < 1131) {
        $('body')
        .addClass('saffireMobileSize')
        .removeClass('saffireLargeSize');
    } if (windowSize > 1130) {
        $('body').removeClass('saffireMobileSize');
    }
    $('.footer .saffire_logo').attr('src', FULLCLIENTTHEMEPATH + '/images/saffire-logo.png');
    $(".email-main .emailSubmitButton").html("Sign UP");
    // General Message
    $('.generalmessage').prependTo('header');
    $('#hlnk_mobileTicketBtn').insertAfter('.mobile-menu-slider');
    $('.footer').clone().appendTo('.mobile-menu-container');
    setTimeout(function() { 
        $( '<div class="mobilemenu-link"><a href="https://www.horseheavenroundup.com/" target="_blank">HORSE HEAVEN ROUND-UP</a></div>' ).insertAfter( $( ".mobile-menu-container .search-container" ) ); 
    }, 3000);
});

$(window).load(function () {
    $(".footerItems1 a").removeClass("button");
    // Weather Bug
    setInterval(function () {
        var str = $('#weatherBugDescription').text();
        var weatherBugSet = $('#weatherBugWidget').hasClass('weatherBugSet');
        if (!weatherBugSet && str != '') {
            $('#weatherBugWidget').addClass('weatherBugSet');
            var findSpace = str.lastIndexOf(' ');
            var stringLength = str.length;
            var res = str.substring(findSpace, stringLength);
            var start = str.substring(0, findSpace);
            $('#weatherBugDescription').html('<span class="weatherDescriptive">' + start + '</span>' + res);
            $('#weatherBugWidget').css('visibility', 'visible');
        }
    }, 12);
    $(".email-main .emailSubmitButton").html("Sign Up");
    $('#hlnk_mobileTicketBtn').insertAfter('.mobile-menu-slider');
});